import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { measurements } from '@mobi/component-library/Theme/Common'
import { ReceiptListRowStyled } from '@core/Areas/Quickbet/Components/Receipt/Receipt.styles'
import { shouldApplySafeAreaBottomPadding } from '@core/Settings/cssConditions'

interface BettingDrawerStyledProps {
  open: boolean
  zIndexOverride?: number
}

export const MAX_DRAWER_CONTENT_WIDTH = '40rem'

export const BettingDrawerStyled = styled.div<BettingDrawerStyledProps>(
  {
    backgroundColor: hexColors.white,
    bottom: 0,
    boxSizing: 'border-box',
    left: 0,
    position: 'fixed',
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: measurements.mobi.bottomTabsHeight,
    paddingBottom: shouldApplySafeAreaBottomPadding ? 'var(--safe-area-inset-bottom, 0)' : 0,
    transition: 'transform 0.2s',
  },

  ({ open, zIndexOverride }) => ({
    transform: `translateY(${open ? 0 : '100%'})`,
    zIndex: zIndexOverride == null ? 8 : zIndexOverride,
  })
)

export const BonusBetReceiptRowStyled = styled(ReceiptListRowStyled)({
  color: hexColors.mariner,
  fontWeight: 'normal',
})
